export default __webpack_public_path__ + "static/media/cz.979220a6.svg";